<template>
    <div class="main">
        <div class="main__head">Skills:</div>
        <div class="main__copy">PHP, JavaScript, CSS3, HTML</div>
        <div class="main__head">Tools:</div>
        <div class="main__copy">Symfony, Vue.js, Polymer.js, Gulp, Webpack, Sass, Git</div>
        <div class="main__head__contact">Kontakt:</div>
        <div class="main__copy">
            <p>Ehrenfeldgürtel 151, 50823 Köln</p>
            <a href="mailto:ralf@casamassa.de">ralf@casamassa.de</a>
        </div>
    </div>
</template>

<script>
  export default {
    components: {
    },
    name: 'MainPage',
    props: {

    },
    data () {
      return {
      }
    },
    created: function () {
    },
    methods: {

    },
    mounted () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .main {
        padding: 20px;

        &__head {
            text-transform: uppercase;
            font-size: 16px;
            font-weight: bold;
            margin-top: 20px;

            &__contact {
                margin-top: 40px;
                text-transform: uppercase;
                font-weight: bold;
            }
        }

        &__copy {
            font-size: 15px;
            padding-top: 10px;

            a {
                color: #2c3e50;
                text-decoration: none;

                &:hover {
                    opacity: 0.7;
                }
            }
        }
    }
</style>
